import React from "react";
import basketball from "./../images/basketball.png";
import rocket from "./../images/rocket.png";
import smiling from "./../images/smiling.png";
import trophy from "./../images/trophy.png";
import bag from "./../images/bag.png";

const images = {
  basketball,
  rocket,
  smiling,
  trophy,
  bag,
};

export const Button = ({ item, classes, handelClick }) => {
  return (
    <button
      onClick={() => handelClick(item.filterKey)}
      className={`${classes} justify-center mr-5 min-w-max items-center flex h-12 px-6 mb-5 rounded-3xl text-lg font-semibold border-2 border-solid border-green-600 text-green-600 outline-none focus:outline-none hover:text-white hover:bg-green-600 hover:shadow-lg`}
    >
      {item.text}
      {item.srcImg && (
        <img src={images[item.srcImg]} alt={item.alt} className="ml-4" />
      )}
    </button>
  );
};
